import type { ResultData, ResultItem } from '@/domain';

type BuildAdUrlParams = {
    contextPath: string;
    adId: string | number;
    bookingFrom?: string | null;
    bookingTo?: string | null;
    numberOfGuests?: number;
};

export const buildAdUrl = ({ contextPath, adId, bookingFrom, bookingTo, numberOfGuests }: BuildAdUrlParams): string => {
    const baseUrl = `${contextPath}/ad.html?finnkode=${adId}`;
    const hasDateParams = bookingFrom && bookingTo;
    const dateParams = hasDateParams ? `&fra=${bookingFrom}&til=${bookingTo}` : '';
    const guestParams = numberOfGuests && numberOfGuests > 0 ? `&gjester=${numberOfGuests}` : '';
    return baseUrl + dateParams + guestParams;
};

export const apiListAdImageWrapper = (res: ResultData): ResultData => {
    if (res?.resultItems && Array.isArray(res.resultItems)) {
        fixAdImages(res.resultItems);
    }
    return res;
};

const fixAdImages = (images: ResultItem[]) => {
    images
        .filter((item) => item.imageurl !== undefined)
        .forEach((item) => {
            item.imageurl = prependImageUrl(item.imageurl);
        });
};

export const prependImageUrl = (imageUrl: string): string => {
    if (imageUrl.includes('http')) {
        return imageUrl;
    } else {
        return `https://images.finncdn.no/dynamic/default/${imageUrl}`;
    }
};
